export default __webpack_public_path__ + "static/news19-dcf0a4ad6033ea998cc26a4fabf22665.jpeg";